import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'hideText',
    standalone: false
})

export class HideTextPipe implements PipeTransform {

    transform(value: string, char: string = '*'): any {
        const length = value.length - 4;
        const arr = [];

        const last4: string = value.substring((value.length - 4), value.length);

        for (let i = 0; i < length; i++) {
            if (value[i] === '-') {
                arr.push('-');
            }
            else {
                arr.push(char);
            }
        }

        const result = [...arr, ...last4];

        return result.join('');

    }
}
